import { useState } from "react";
import { LcmModel } from "../../domain/LcmModel";
import { EntityDialog, DialogType } from "./types";
import { buildDefinitions } from "./buildDefinitions";
import { ActivityFeed} from "@ofqual/portal-activity-feed";
import { RenderDialog } from "./RenderDialog";
import { useAuth, useLookup } from "@ofqual/portal-core/core/hooks";
import { authSelector } from "../../redux/selectors";
import { UserType } from "../../redux/types";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    caseNoteTypeLookupService,
    counselCategoryLookupService, projectPolicyCategoryService,
} from "../../services";
import ConfirmDialog from "./dialogs/ConfirmDialog";
import React from "react";

type LcmActivityFeedProps = {
    lcmItem: LcmModel;
};

export const LcmActivityFeed: React.FC<LcmActivityFeedProps> = ({
    lcmItem,
}) => {
    const [focusedEntity, setFocusedEntity] = useState<EntityDialog | null>(null);

    const { userType, upn } = useAuth(authSelector);
    const { roles } = useSelector(authSelector);

    const canEdit = userType === UserType.Ofqual;

    const [counselCategoryLookups, caseNoteLookups, projectPolicyLookups] = useLookup(
        counselCategoryLookupService,
        caseNoteTypeLookupService,
        projectPolicyCategoryService,
    );

    const [showConfirm, setShowConfirm] = useState(false);
    const [showConfirmFunc, setShowConfirmFunc] = useState<void>();
    const [confirmText, setConfirmText] = useState(
        "Are you sure want to complete this action"
    );

    // const hasLineManagerAssigned =
    //     lcmItem.lineManagerUpn !== null && lcmItem.lineManagerUpn.trim().length > 0;

    const definitions = buildDefinitions(
        (activity, dialogType) =>
        (setFocusedEntity({
            dialogType: dialogType || DialogType.ActivityAction,
            focusedActivity: activity,
        })),
        lcmItem,
        roles,
        useDispatch(),
        upn,
        counselCategoryLookups,
        caseNoteLookups,
        projectPolicyLookups,
        setShowConfirm,
        setShowConfirmFunc,
        setConfirmText
    );

    const defaultActions = [
        {
            label: "Options",
            disabled: false,
            dataTest: "options-event-button",
            action: () => setFocusedEntity({ dialogType: DialogType.OptionMenuEvent }),
        },
    ];

    const allowedActions = canEdit ? defaultActions : [];

    return (
        <>
            <ConfirmDialog
                show={showConfirm}
                setShow={setShowConfirm}
                title="Confirm"
                content={confirmText}
                onConfirm={showConfirmFunc !== undefined ? showConfirmFunc : undefined}
            />
            <ActivityFeed
                resourceId={lcmItem.id.toString()}
                definitions={definitions}
                actions={allowedActions}
            />
            {canEdit && (
                <RenderDialog
                    focusedEntity={focusedEntity}
                    onClose={() => setFocusedEntity(null)}
                    lcmItem={lcmItem}
                    setFocusedEntity={setFocusedEntity}
                />
            )}
        </>
    );
};
